import React from "react";
import { Box, Typography, Chip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TOOTH_STATUSES } from "./DentalChartUtils";
import useBDocTranslator from "../../hooks/useBDocTranslator";

const useStyles = makeStyles((theme) => ({
  legendContainer: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1),
    backgroundColor: theme.palette.action.hover,
    borderRadius: theme.spacing(0.5),
    border: `1px solid ${theme.palette.divider}`,
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden",
    boxSizing: "border-box",
  },
  legendTitle: {
    marginBottom: theme.spacing(0.5),
    fontWeight: "bold",
    color: theme.palette.text.primary,
    fontSize: "0.875rem",
  },
  statusChip: {
    margin: theme.spacing(0.25),
    height: "24px",
    "& .MuiChip-avatar": {
      width: "14px",
      height: "14px",
      marginLeft: "4px",
    },
    "& .MuiChip-label": {
      fontSize: "0.7rem",
      padding: "0 8px",
    },
  },
  colorIndicator: {
    width: "14px",
    height: "14px",
    borderRadius: "2px",
    border: "1px solid #ccc",
    marginRight: "4px",
  },
}));

const DentalChartLegend = () => {
  const classes = useStyles();
  const { t } = useBDocTranslator();

  return (
    <Box className={classes.legendContainer}>
      <Typography variant="subtitle2" className={classes.legendTitle}>
        {t("Tooth Status Legend")}
      </Typography>
      <Box display="flex" flexWrap="wrap" alignItems="center">
        {Object.entries(TOOTH_STATUSES).map(([statusKey, statusValue]) => (
          <Chip
            key={statusKey}
            size="small"
            variant="outlined"
            className={classes.statusChip}
            avatar={
              <div
                className={classes.colorIndicator}
                style={{
                  backgroundColor: statusValue.fill || "transparent",
                  borderColor: statusValue.stroke,
                  borderWidth: "2px",
                }}
              />
            }
            label={t(statusValue.label)}
          />
        ))}
      </Box>

      <Typography
        variant="caption"
        color="textSecondary"
        style={{ marginTop: "4px", display: "block", fontSize: "0.7rem" }}
      >
        {t("Click on any tooth to change its status")}
      </Typography>
    </Box>
  );
};

export default DentalChartLegend;
